export const API_ENDPOINTS = {
  LOOKUP_LICENSE_ENDORSEMENT: '/platform/master/lookup/category/LICENSE-ENDORSEMENT',
  DOMAIN_LOOKUP: '/domain/lookup',
  DOMAIN_LOOKUP_BY_TYPE: '/domain/lookup?requestType=',
  APPLICATION_TYPES_LOOKUP: '/domain/lookup?requestType=APPLICATION_TYPES',
  APPLICATION_STATUS_LOOKUP: '/domain/lookup?requestType=APPLICATION_STATUS',
  LOOKUP_MESSAGES: '/domain/lookup?requestType=MESSAGES',
  ORG_USERS: '/org/user',
 applications:'/registration/applications',
  REGISTRATION_TAB_QUEUE_DATA: '/queues/tab-queue-data',
  PERSONS_BY_ROLE: '/queues/persons-by-role',
  Is_Case_Archived:'/queues/case_details',
  TEMP_LOCK_QUEUE_APPLICATION: '/queues/update-lock-status-queue-application',
  GET_LOCK_STATUS: '/queues/lock-status',
  DOWNLOAD_APPLICATION : '/queues/download-application',
  LOOKUP_REQUEST_TYPES: {
    APPLICATION_TYPES: 'APPLICATION_TYPES',
    APPLICATION_STATUS: 'APPLICATION_STATUS'
  },
  TOAST_MESSAGES: '/domain/lookup?requestType=TOAST MESSAGES',
  MESSAGES: '/domain/lookup?requestType=MESSAGES',
  GET_DETAILS: '/registration/getRegistrationDetailsByEmail?email=',
  GENERIC_MESSAGES: '/domain/lookup?requestType=GENERIC MESSAGES',
  PLACEHOLDER_MESSAGES: '/domain/lookup?requestType=PLACEHOLDER MESSAGES',
  BUSINESS_RULES: '/business-rules/fetch-buisness-rules',
  INSERT_BUSINESS_RULE: '/business-rules/insert-buisness-rule',
  UPDATE_BUSINESS_RULE: '/business-rules/update-buisness-rule',
  BUSINESS_RULES_HEADERS: 'assets/metadata/business-rules-headers.json',
  SUFFIX: '/domain/lookup?requestType=SUFFIX',
  LOOKUP_GRADE_LEVEL: '/domain/lookup?requestType=GRADE-LEVEL',
  LOOKUP_LICENSE_TYPES: '/domain/lookup?requestType=LICENSE-TYPES',
  LOOKUP_ENDORSEMENT: '/domain/lookup?requestType=ENDORSEMENT',
  LOOKUP_LICENSE_REQUIREMENT_CATEGORY: '/domain/lookup?requestType=LICENSE-REQUIRMENT-CATEGORY',
  UPDATE_INTERNAL_USER: '/registration/updateInternalUser',
  appData: '/application-flow/appData',
  DASHBOARD_DATA: '/dashboard/dashboard-data',
  EDUCATOR_DASHBOARD_DATA: '/search/educator-dashboard-data',
  EDUCATOR_ADMIN_MANUAL_TRANSACTION: '/search/educator-admin-manual-transaction',
  DOCUMENT_DOWNLOAD: '/dashboard/document-download',
  EXTEND_LICENSE: '/dashboard/extend-license',
  EXTEND_LICENSE_EDUCATORPROFILE: '/dashboard/extend-license_educator_profile',
  FPRINT_SUB_METHOD : '/domain/lookup?requestType=FPRINT_SUB_METHOD',
  fetchFingerPrintDetails: '/fingerprint/fetch-fingerprint-record',
  updateFingerPrintRecord: '/fingerprint/update-fingerprint-record',
  notifiction:'/platform/notification',
  SUBMITPAYMENT:'/payments/pay',
  PAYMENT_BREAKDOWN: '/dashboard/payment-breakdown',  
  EMAIL_LOGS: '/dashboard/email-logs',
  EMAIL_LOGS_BY_PERSON: '/search/email-logs',
  RESEND_EMAIL_LOG_BY_ID: '/search/resend-email',
  UPDATE_DOCUMENT_NOTES: '/search/update-notes',
  communicationData:'/registration/case-communication',
  fetchBusinessRules: '/business-rules/fetch-buisness-rules',
  lastLogin: '/application-flow/last-login',
  LOGOUT_HISTORY: '/application-flow/logout-history',
  UNLOCK_APPLICATION: '/queues/unlock-application',
  RCR_QUESTIONS: '/application-flow/rcr-questions',
  RCR_QUESTION_BY_KEY: '/application-flow/rcr-question-by-key',
  PORTAL_TEMPLATE:'/lea-portal/get-data-templates',
  LEA_PORTAL_TEMPLATE :'/lea-portal/portal-document-upload',
  PORTAL_DOCUMNET_DOWNLOAD:'/lea-portal/document-download',
  SYSTEM_CONFIG_AUDIT_TRAILS:'/audit-trails/audit-trails-data',
  DATA_TEMPLATES : {
    GETPORTAL_TYPES : '/data-template/data-template-types',
    GETPORTAL_NAMES : '/data-template/data-template-names',
    GETTEMPLATE_COLUMNS : '/data-template/data-template',
    SAVE_TEMPLATE_COLUMNS : '/data-template/save-data-template',
    UPDATE_TEMPLATE_COLUMNS : '/data-template/edit-data-template',
    GET_PORTAL_TEMPLATES  : '/data-template/data-template-names',
    DOWNLOAD_TEMPLATES  : '/data-template/download',
    UPLOAD_TEMPLATES : '/data-template/upload',
    FETCH_SUBMISSION_LIST : '/data-template/data-submissionlist',
    FETCH_REFERENCE_DOCUMENTS : '/data-template/template-upload-list',
    FETCH_ACTIVE_REFERENCE_DOCUMENTS : '/data-template/ref-template-documents-active',
    DOWNLOAD_REFERENCE_DOCUMENT : '/data-template/ref-template-document-download',
    UPLOAD_REFERENCE_DOCUMENT : '/data-template/ref-template-document-upload',
    ACTIVATE_REFERENCE_DOCUMENT : '/data-template/ref-template-document-status',
    DELETE_REFERENCE_DOCUMENT : '/data-template/ref-template-document-delete',
    DEACTIVATE_LEA_TEMPLATE : '/data-template/data-template-activate-deactivate',
    DEACTIVATE_EPP_TEMPLATE : '/data-template/data-template-activate-deactivate',
    DELETE_TEMPLATE_DATA : '/data-template/deletebycolsel',
  },
   FETCH_SURRENDER : '/dashboard/get-surrender-license-data',
   GET_SURRENDER_APPLICATION_DATA : '/dashboard/get-surrender-application-data',
  CREATE_SURRENDER_APPLICATION : '/dashboard/create-surrender-application',
  LOOKUP_LICENSE_PATH: '/domain/lookup?requestType=LICENSE_PATH',
  SAVE_ARL_PROGRAM_FIELDS: '/application-flow/save-arl-program-fields',
  GET_ARL_PROGRAM_FIELDS: '/application-flow/get-arl-program-fields',
  Profile_Notes_Upload: '/search/educator-communication-upload',
  EDUCATOR_COMMUNICATION_DOWNLOAD: '/search/educator-communication-download',
  EDUCATOR_PROFILE_DOCUMENT_UPLOAD: '/search/educator-profile-document-upload',
  USER_EDUCATOR_TAB: {
    Insert_Academic_BgData: '/search/addAcademicBackground',
    UPDATE_PROF_DEV_HOURS :  '/search/updateProfDevCourseHours',
    Insert_EMP_DEV_HOURS: '/search/updateEmpProfDevHours',
    Insert_Additional_Dev_Hours: '/search/updateAdditonalProfHrs',
    Update_AcademicBackground: '/search/update-academic-background',
    Update_Employment_DevHrs:'/search/update-employment-prof-hrs',
    Update_Additional_DevHrs: '/search/update-additional-prof-hrs',
    Deletion_across_grids: '/search/deletion-education-grids',
    Update_Program_Data:'/search/update-program-notes',
    Update_Transcript_Status: '/search/update-academic-transcript-status'
  },
  USER_EXPERIENCE_TAB:{
    Insert_Out_of_state:'/search/educator-insert-out-of-state-license',
    Insert_Verifiable_teaching_experience:'/search/educator-insert-teaching-experience',
    Insert_Assignment_experience:'/search/educator-insert-assignment-experience',
    Insert_Employment:'/search/educator-insert-employment-experience',
    Update_Out_of_state:'/search/educator-update-out-of-state-license',
    Update_Verifiable_teaching_experience:'/search/educator-update-teaching-experience',
    Update_Assignment_experience:'/search/educator-update-assignment-experience',
    Update_Employment:'/search/educator-update-employment-experience',
    Delete_Verifiable_teaching_experience:'/search/educator-delete-teaching-experience',
    Delete_Out_of_state:'/search/educator-delete-out-of-state',
    Delete_Employment: '/search/educator-delete-employment',
    Insert_Business_industry: '/search/educator-insert-business-industry-experience',
    Update_Business_industry: '/search/educator-update-business-industry-experience',
    Delete_Business_industry: '/search/educator-delete-business-industry-experience'
  },
  EDUCATOR_ADD_NEVADA_TEST: '/search/educator-add-nevada-test',
  EDUCATOR_ADD_OOS_TEST: '/search/educator-add-oos-test',
  LOOKUP_TEST_NAMES: '/domain/lookup?requestType=TEST NAME',
  LOOKUP_STATES: '/domain/lookup?requestType=STATE',
  LOOKUP_OOS_EXAM_NAMES: '/domain/lookup?requestType=TEST NAME',
  LOOKUP_OOS_RESULT: '/domain/lookup?requestType=OUT_OF_STATE_RESULT',
  LICENSE_REVERSE_EXTENSION : '/search/reverse-license',
  EDUCATOR_UPDATE_DOCUMENT: '/search/educator-update-document',
  EDUCATOR_DELETE_DOCUMENT: '/search/educator-delete-document',
  EDUCATOR_ARCHIVE_DOCUMENT: '/search/educator-archive-document',
  EDUCATOR_UNARCHIVE_DOCUMENT: '/search/educator-unarchive-document',
  EDUCATOR_DOCUMENT_UPLOAD: '/search/educator-document-upload',
  LOOKUP_DOCUMENT_CATEGORY: '/domain/lookup?requestType=DOCUMENT CATEGORY',
  LOOKUP_DOCUMENT_TYPE: '/domain/lookup?requestType=DOCUMENT TYPE',
  LOOKUP_REVENUE_CODE_DESC: '/domain/lookup?requestType=REVENUE_CODE_DESC',
  EDUCATOR_RESEND_SUBMISSION_EMAIL: '/search/educator-resend-submission-email',
  EDUCATOR_EDIT_NEVADA_TEST: '/search/educator-edit-nevada-test',
  EDUCATOR_DELETE_NEVADA_TEST: '/search/educator-delete-nevada-test',
  EDUCATOR_EDIT_OOS_TEST: '/search/educator-edit-oos-test',
  EDUCATOR_DELETE_OOS_TEST: '/search/educator-delete-oos-test',
  EDUCATOR_NOTES_DELETE:'/search/educator-delete-note',
  DOC_CATEGORY : '/search/doccategory',
  DOC_CATEGORYTYPE : '/search/doccategorytype',
  REPORTS:'/reports/reports-data',
  GENERATE_REPORT: '/reports/generate-report',
  INTERNAL_NOTES_QUEUES: '/queues/tab-notes',
  SEARCH_COMMUNICATION_DOCUMENT_TYPES: '/search/doccategory/person',
  CONTENT_MANAGEMENT: {
    GET_CONTENT: '/content-management/content',
    GET_CONTENT_BY_KEY: '/content-management/content',
    SAVE_CONTENT: '/content-management/content',
  },
  lookupSchoolYears: '/domain/lookup?requestType=SCHOOL-YEAR'
} as const;

export type ApiEndpoints = typeof API_ENDPOINTS;